module.exports = __webpack_public_path__ + "img/delta-to-delta-3-phase-trafo.4a8b7ce3.svg";